import { Component } from '@angular/core';
import { BaseFormComponent } from '../base-form.component';

@Component({
  moduleId: module.id,
  selector: 'custom-family-member',
  templateUrl: './custom-family-member.component.html',
})
export class CustomFamilyMember extends BaseFormComponent {
  mask = {
    guide: true,
    mask: [/^([0-1])/, /\d/, '/', /^(0|1|2|3)/, /\d/, '/', /^(1|2)/, /^(9|0|1)/, /\d/, /\d/],
    placeholder: 'MM/DD/YYYY',
  };

  relationshipToInsuredOptions = [
    { value: '2', description: 'Parent' },
    { value: '3', description: 'Legal Guardian' },
    { value: '5', description: 'Sibling' },
  ];

  getFullPropString(property: string): string {
    return this.handleIterate(property);
  }

  relationshipDisplayText(): string {
    return this.parsePredicates("Relationship to {{'noun': 'insured', 'type': 'subject'}}");
  }
  updateFromModel(): void {}
}
